var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":("img/logo/main/" + (_vm.isWebExpensesApp ? 'webexpenses' : 'zudello') + ".png"),"alt":_vm.appDisplayName}})}
var staticRenderFns = []

export { render, staticRenderFns }